<template>
  <div>
    <div class="section">
      <div class="container section__content">
        <h2 class="std__subtile daily">{{ $t("terms") }}</h2>

        <div class="row">
          <div class="contentPanel" style="padding-top: 5px !important">
            <div class="policy_wrap">
              <div class="mobiSection">
                <div class="mobiSection__content">
                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">Použitelnost</h2>
                    <p class="mobitxt">
                      Níže uvedené podmínky (Všeobecné podmínky) platí pro
                      anglickou verzi jednorázové placené služby Mobiscope
                      Premium (Puretech Global Sdn Bhd a / nebo Služba) nabízené
                      online prostřednictvím internetu od společnosti Puretech
                      Global Sdn Bhd (dále jen jako Puretech Global Sdn Bhd).
                      Koncový uživatel vyžaduje službu Mobiscope od společnosti
                      Puretech Global Sdn Bhd.
                    </p>
                  </div>

                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">Obvykle</h2>
                    <p class="mobitxt">
                      Mobiscope poskytuje nejlepší sexy tapety a videa výhradně
                      pro váš mobil.
                    </p>
                  </div>
                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">
                      Potvrzení / registrace
                    </h2>
                    <p class="mobitxt">
                      Aby měl koncový uživatel přístup k Mobiscope, musí zadat
                      číslo svého mobilního telefonu a / nebo určitá další data
                      a / nebo informace prostřednictvím propagační webové
                      stránky (Landing Pages) provozované společností Puretech
                      Global Sdn Bhd. Poté koncový uživatel obdrží na své
                      mobilní zařízení SMS, s osobním identifikačním číslem (PIN
                      kód), nebo takzvanou nabídkovou zprávou s informacemi o
                      službě. Koncový uživatel zadáním přijatého PIN kódu na
                      úvodní stránce a / nebo odesláním potvrzovací zprávy a /
                      nebo používáním služby potvrzuje a potvrzuje, že si
                      přečetl Všeobecné podmínky, je autorizovaným majitelem
                      účtu mobilního telefonu nebo má souhlas plátce telefonního
                      účtu s využitím této služby. Koncový uživatel obdrží
                      potvrzovací SMS zprávu o úspěšné aktivaci služby
                      Mobiscope, způsobu, frekvenci a nákladech na stažení
                      Služby a také přesné údaje o odhlášení.
                    </p>
                  </div>
                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">Náklady a poplatky</h2>
                    <p class="mobitxt">
                      Mobiscope je placená služba, která stojí 3 SMS x 1,60 EUR
                      / týden Poplatek bude účtován na účet za mobilní telefon
                      nebo na předplacené mobilní číslo. Způsob účtování je
                      Premium MT SMS zasílaná Koncovému uživateli na základě
                      jeho požadavku na službu Mobiscope. Tato zpráva bude
                      obsahovat vaše přihlášení do Mobiscope. Poplatky se
                      vybírají podle provozovatelů mobilních sítí. Poplatky jsou
                      odepsány na účet Koncového uživatele Provozovatelem; v
                      případě SIM s předplatným jsou poplatky odečteny z kreditu
                      Koncového uživatele. Koncový uživatel tímto výslovně
                      uděluje své oprávnění účtovat poplatky a zavazuje se
                      uhradit v plné výši poplatky vzniklé v důsledku
                      předplatného a / nebo používání služby Mobiscope. Pokud
                      nejste osobou odpovědnou za zaplacení účtu za mobilní
                      telefon, před přihlášením a / nebo použitím Mobiscope si
                      prosím vyžádejte povolení od svého mobilního plátce.
                      Podpisem a / nebo účastí ve službě Puretech Global Sdn Bhd
                      předpokládá, že koncový uživatel získal potřebné povolení,
                      souhlas nebo schválení od plátce mobilního účtu,
                      opatrovníka nebo rodičů. Všechny SMS zprávy zasílané
                      koncovým uživatelem budou mobilním operátorem koncového
                      uživatele účtovány za standardní tarif. Tyto sazby se
                      mohou u jednotlivých operátorů lišit. Další informace o
                      poplatcích vám poskytne váš mobilní operátor GSM.
                    </p>
                  </div>
                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">Pomoc a podpora</h2>
                    <p class="mobitxt">
                      Zákaznický servis je k dispozici v pracovní dny od 09:00
                      do 17:00 Kontakt: +421 313215999 nebo
                      mobiscope.cz@silverlines.info
                    </p>
                  </div>
                  <div class="mobiFaq">
                    <h2 class="mobiTitle sm text_color">Duševní vlastnictví</h2>
                    <p class="mobitxt">
                      Službu můžete používat pro osobní, nekomerční použití.
                      Pojem Mobiscope a všechny ostatní ochranné známky,
                      servisní značky a / nebo obchodní názvy používané
                      společností Mobiscope ve Službě čas od času (ochranné
                      známky) jsou ochranné známky, servisní značky a / nebo
                      obchodní názvy společnosti Puretech Global Sdn Bhd nebo
                      jedné z jejích společností v skupina nebo její
                      poskytovatelé licencí a tyto subjekty si vyhrazují veškerá
                      práva k ochranným známkám. Kromě toho další obsah Služby,
                      mimo jiné včetně her, obrázků, obrázků, grafik,
                      fotografií, animací, videí, hudby, zvuku a textu, patří
                      společnosti Mobiscope nebo jedné z jejích společností a /
                      nebo licencovaných skupin a je chráněn autorským právem a
                      / nebo jinými právy duševního vlastnictví. Berete na
                      vědomí, že používáním Služby nezískáte žádná práva na
                      ochrannou známku ani Obsah Služby, než jak je uvedeno v
                      této Smlouvě. Za žádných okolností nesmíte za žádných
                      okolností kopírovat jakýkoli obsah služby (včetně, bez
                      omezení, vědomostních otázek, odpovědí nebo her), ani ve
                      službě používat dolování dat, roboty, škrábance na
                      obrazovce nebo podobné nástroje pro sběr a extrakci dat.
                      Odpovědnost Používání Mobiscope a / nebo webových stránek
                      Mobiscope je na vlastní riziko koncového uživatele.
                      Koncový uživatel musí poskytnout plně kompatibilní mobilní
                      telefon, hardware nebo jiná zařízení a software a
                      zajistit, aby byly funkční a vhodné pro služby Mobiscope.
                      Mobiscope nemůže zaručit, že služby Mobiscope splňují
                      požadavky koncového uživatele a že stahování, přijímání a
                      / nebo prohlížení služeb Mobiscope proběhne bez přerušení
                      nebo chyb. Pokud koncový uživatel nemůže kdykoli využívat
                      službu Puretech Global Sdn Bhd bez přerušení, v žádném
                      případě to nezakládá právo na snížení poplatků za služby
                      Mobiscope, jakékoli právo na vrácení předplacených plateb.
                      Jakékoli použití služeb Mobiscope je na uvážení a riziku
                      koncového uživatele, a to za, nikoli však výhradně,
                      infekci nebo kontaminaci, ztrátu dat nebo poškození
                      hardwaru a / nebo softwaru koncového uživatele v důsledku
                      přístup na webové stránky nebo používání služeb Mobiscope
                      nebo stažených služeb Mobiscope, včetně hardwaru a
                      softwaru nutného pro připojení ke službám Mobiscope. Je
                      odpovědností koncových uživatelů, aby přijali nezbytná
                      opatření, která zabrání možnému poškození tohoto druhu. V
                      případě, že je společnost Mobiscope z jakéhokoli důvodu
                      povinna nahradit koncovému uživateli přímé nebo následné
                      škody jakéhokoli druhu, nesmí tato náhrada v žádném
                      případě překročit hodnotu faktury za služby Mobiscope,
                      kterou koncový uživatel zaplatil za údajné škody. Obsah
                      webových stránek byl sestaven s největší péčí. Společnost
                      Mobiscope však nemůže poskytnout žádnou záruku, pokud jde
                      o povahu, přesnost nebo obsah těchto informací. Mobiscope
                      nenese odpovědnost za chyby, opomenutí, nepřesnosti,
                      nedorozumění, zpoždění nebo nečitelné objednávky nebo
                      oznámení založená na používání internetu nebo příslušného
                      informačního bodu. Závěrečná ustanovení Veškeré spory
                      týkající se plnění těchto Obchodních podmínek budou řešit
                      příslušné obecné soudy. Puretech Global Sdn Bhd si
                      vyhrazuje právo čas od času tyto podmínky změnit. Změny
                      budou koncovým uživatelům oznámeny zveřejněním na portálu
                      Mobiscope.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: mapGetters(["countryCode"]),
  mounted() {},
};
</script>





// WEBPACK FOOTER //
// src/components/mobiscope/TermsCzech.vue